import { SxProps, Theme } from '@mui/material';

export const badgePlpContainerSx: SxProps<Theme> = {
	'&.badge_plp': {
		position: 'absolute',
		zIndex: 2,
		padding: '2px 5px',
		backgroundColor: '#3e7697',
		color: '#ffffff',
		fontSize: '12px',
		top: '4px',
		left: '15px',
		fontWeight: 600,
		borderBottomLeftRadius: '3px',
		borderBottomRightRadius: '3px',
	},
	'&.badge_plp::after': {
		content: '""',
		height: '5px',
		position: 'absolute',
		zIndex: 0,
		top: 0,
		right: '-5px',
		borderLeft: '5px solid transparent',
		borderTop: '5px solid #eee',
		backgroundColor: '#55565A',
	},
	'&.badge_plp-hs': {
		backgroundColor: '#E02631',
		'&::after': {
			backgroundColor: '#000000',
			borderBottom: '5px solid #000000',
		},
	},
	'&.badge_plp-bf': {
		backgroundColor: '#000000',
		'&::after': {
			backgroundColor: 'red',
		},
	},
	'&.badge_plp-cd': {
		backgroundColor: '#000000',
		'&::after': {
			backgroundColor: '#F96302',
		},
	},
};
